import React from "react";

const Transitions: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <mask
      id="mask0_5159_34691"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="14"
      height="15"
    >
      <rect y="0.000183105" width="14" height="14" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5159_34691)">
      <path
        d="M2.91667 12.8335C2.59583 12.8335 2.32118 12.7193 2.09271 12.4908C1.86424 12.2623 1.75 11.9877 1.75 11.6668V5.08976C1.575 4.98281 1.43403 4.84427 1.32708 4.67413C1.22014 4.50399 1.16667 4.30712 1.16667 4.08351V2.33351C1.16667 2.01267 1.2809 1.73802 1.50937 1.50955C1.73785 1.28108 2.0125 1.16684 2.33333 1.16684H11.6667C11.9875 1.16684 12.2622 1.28108 12.4906 1.50955C12.7191 1.73802 12.8333 2.01267 12.8333 2.33351V4.08351C12.8333 4.30712 12.7799 4.50399 12.6729 4.67413C12.566 4.84427 12.425 4.98281 12.25 5.08976V11.6668C12.25 11.9877 12.1358 12.2623 11.9073 12.4908C11.6788 12.7193 11.4042 12.8335 11.0833 12.8335H2.91667ZM2.91667 5.25017V11.6668H11.0833V5.25017H2.91667ZM2.33333 4.08351H11.6667V2.33351H2.33333V4.08351ZM5.25 8.16684H8.75V7.00017H5.25V8.16684Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default Transitions;
